import ConsentReportWrapper from "../components/ConsentReportWrapper/ConsentReportWrapper";

export default function ConsentReportsPage() {
    return <ConsentReportWrapper />;
}
